// extracted by mini-css-extract-plugin
export default {"image":"ImageContainer_image__7iyEm","image_container":"ImageContainer_image_container__h2tFh"};